import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ClockCircleOutlined } from '@ant-design/icons';
import parse from 'html-react-parser';
import Urlbox from './Urlbox';
import ModalQRcode from '../../../../policy/PrivacyNotices/components/ModalQRcode';
import { Tooltip } from 'antd';

const TemplateLink = ({
    detail,
    setVisibleHistories,
    previewLang,
    setIsChangeStatus,
}) => {
    const { t, i18n } = useTranslation('consent');
    const lang = i18n?.language;
    // History

    const url = `${window.location.origin}/${
        detail?.templateType === 'Consent' ? 'consent' : 'term-and-condition'
    }/${previewLang}/${detail?.templateKey}`;
    const iframecode = `<iframe frameborder="0" scrolling="no" width="100%" src="${url}?ember=1" id="template_design_whitefact"></iframe>`;
    const [openQr, setOpenQr] = useState(false);
    const scriptCode = `<script type="text/javascript">function genarated_height_iframe_template_design(e){let t=document.getElementById("template_design_whitefact");e.data&&"template_design_iframe_height"===e.data.type&&(t.style.height=e.data.height+"px")}window.addEventListener("message",genarated_height_iframe_template_design,!1);</script>`;

    return (
        <div className="bg-white rounded-md shadow-sm w-full py-2 px-6">
            <div className="flex justify-between pt-4 items-center">
                <div className="font-semibold text-base">
                    {parse(
                        `${
                            lang === 'en'
                                ? detail?.templateNameEn
                                : detail?.templateNameTh
                        }`
                    )}
                </div>
                <div className="flex gap-2 items-center">
                    <div className="flex-col gap-1 text-right">
                        <div className="font-normal text-sm text-[#65707A]">
                            {t('Version')} : {detail?.version}
                        </div>
                    </div>
                    <button
                        className="bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg text-purple text-sm cursor-pointer"
                        onClick={(e) => {
                            setVisibleHistories(true);
                            setIsChangeStatus(true);
                        }}
                    >
                        <ClockCircleOutlined />
                    </button>
                </div>
            </div>
            <div
                className="my-2"
                style={{ borderBottom: '1px solid #DBDBDB' }}
            ></div>
            <div className="flex space-x-4">
                <div className="flex-1">
                    <label className="font-semibold text-xs">
                        {t('Copy URL')}
                    </label>
                    <div className="rounded-md">
                        <Urlbox status={detail?.status} code={url} />
                    </div>
                </div>
                {detail?.status === 'Draft' ? (
                    <div>
                        <label className="font-semibold text-xs">
                            {t('QR Code')}
                        </label>
                        <div className="cursor-not-allowed bg-gray-100 w-full px-4 py-3 flex justify-center items-center rounded-lg">
                            {QRDisable}
                        </div>
                    </div>
                ) : (
                    <button
                        onClick={() => {
                            setOpenQr(true);
                        }}
                    >
                        <label className="font-semibold text-xs">
                            {t('QR Code')}
                        </label>
                        <div className="hover:opacity-80 cursor-pointer bg-gray-100 w-full px-4 py-3 flex justify-center items-center rounded-lg">
                            {QR}
                        </div>
                    </button>
                )}
            </div>
            <div className="space-y-6 my-6">
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <label className="font-semibold text-xs">
                            {t('Template Key')}
                        </label>
                        <div className="rounded-md bg-gray-100">
                            <Urlbox
                                rows={1}
                                status={detail?.status}
                                code={detail?.templateKey}
                            />
                        </div>
                    </div>
                </div>
                <div>
                    <span className="font-semibold text-xs">
                        IFrame{' '}
                        <Tooltip
                            overlayClassName="!max-w-[320px] rounded"
                            placement="rightTop"
                            title={
                                <ul className="list-decimal px-4">
                                    <li>
                                        ทำการคัดลอก iFrame และนำ iFrame ไปวางใน{' '}
                                        {'<body></body>'} HTML
                                        ในหน้าจอที่คุณต้องการ{' '}
                                    </li>
                                    <li>คัดลอก Script ไปวางต่อท้าย iFrame</li>
                                </ul>
                            }
                        >
                            <a className="text-[#1890FF] ml-4">วิธีการใช้งาน</a>
                        </Tooltip>
                    </span>
                    <div className="rounded-md bg-gray-100">
                        <Urlbox status={detail?.status} code={iframecode} />
                    </div>
                </div>
                <div>
                    <span className="font-semibold text-xs">Script</span>
                    <div className="rounded-md bg-gray-100">
                        <Urlbox
                            status={detail?.status}
                            rows={4}
                            code={scriptCode}
                        />
                    </div>
                </div>
            </div>
            <ModalQRcode
                open={openQr}
                handelClose={() => {
                    setOpenQr(false);
                }}
                handelOk={() => {
                    setOpenQr(false);
                }}
                qrPath={url}
            />
        </div>
    );
};

const QR = (
    <svg
        width="33"
        height="32"
        viewBox="0 0 33 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_3017_13754)">
            <path
                d="M30.9366 20.3365C30.2108 20.3365 29.6241 20.9245 29.6241 21.649V27.8703C29.6241 28.5619 29.061 29.125 28.3707 29.125H22.1494C21.4236 29.125 20.8369 29.713 20.8369 30.4375C20.8369 31.162 21.4236 31.75 22.1494 31.75H28.3707C30.51 31.75 32.2491 30.0096 32.2491 27.8703V21.649C32.2491 20.9245 31.6624 20.3365 30.9366 20.3365Z"
                fill="#1890FF"
            />
            <path
                d="M2.0625 20.3365C1.33669 20.3365 0.75 20.9245 0.75 21.649V27.8702C0.75 30.0096 2.48906 31.75 4.62844 31.75H10.8497C11.5755 31.75 12.1622 31.162 12.1622 30.4375C12.1622 29.713 11.5755 29.125 10.8497 29.125H4.62844C3.93806 29.125 3.375 28.5619 3.375 27.8702V21.649C3.375 20.9245 2.78831 20.3365 2.0625 20.3365Z"
                fill="#1890FF"
            />
            <path
                d="M28.3707 0.249586H22.1494C21.4236 0.249586 20.8369 0.837585 20.8369 1.56209C20.8369 2.28659 21.4236 2.87459 22.1494 2.87459H28.3707C29.061 2.87459 29.6241 3.43765 29.6241 4.12933V10.3506C29.6241 11.0751 30.2108 11.6631 30.9366 11.6631C31.6624 11.6631 32.2491 11.0751 32.2491 10.3506V4.12933C32.2491 1.98996 30.51 0.249586 28.3707 0.249586Z"
                fill="#1890FF"
            />
            <path
                d="M10.8497 0.249586H4.62844C2.48906 0.249586 0.75 1.98996 0.75 4.12933V10.3506C0.75 11.0751 1.33669 11.6631 2.0625 11.6631C2.78831 11.6631 3.375 11.0751 3.375 10.3506V4.12933C3.375 3.43765 3.93806 2.87459 4.62844 2.87459H10.8497C11.5755 2.87459 12.1622 2.28659 12.1622 1.56209C12.1622 0.837585 11.5755 0.249586 10.8497 0.249586Z"
                fill="#1890FF"
            />
            <path
                d="M13.1889 17.1038H6.65527C5.92946 17.1038 5.34277 17.6918 5.34277 18.4163V25.8437C5.34277 26.5682 5.92946 27.1562 6.65527 27.1562H13.1889C13.9147 27.1562 14.5014 26.5682 14.5014 25.8437V18.4163C14.5014 17.6918 13.9134 17.1038 13.1889 17.1038ZM7.96777 19.7288H11.8764V24.5312H7.96777V19.7288Z"
                fill="#1890FF"
            />
            <path
                d="M26.3447 4.84375H20.1104C19.3845 4.84375 18.7979 5.43175 18.7979 6.15625V10.3326C18.7979 11.0571 19.3845 11.6451 20.1104 11.6451C20.8362 11.6451 21.4229 11.0571 21.4229 10.3326V7.46875H25.0322V11.4062H23.4809C22.755 11.4062 22.1684 11.9943 22.1684 12.7188C22.1684 13.4433 22.755 14.0312 23.4809 14.0312H26.3447C27.0705 14.0312 27.6572 13.4433 27.6572 12.7188V6.15625C27.6572 5.43175 27.0705 4.84375 26.3447 4.84375Z"
                fill="#1890FF"
            />
            <path
                d="M26.345 19.1618H20.9756C20.2498 19.1618 19.6631 19.7498 19.6631 20.4743V25.8438C19.6631 26.5683 20.2498 27.1562 20.9756 27.1562H26.345C27.0708 27.1562 27.6575 26.5683 27.6575 25.8438V20.4743C27.6575 19.7498 27.0708 19.1618 26.345 19.1618ZM22.2881 21.7868H25.0325V24.5313H22.2881V21.7868Z"
                fill="#1890FF"
            />
            <path
                d="M17.1264 13.1952H6.65527C5.92946 13.1952 5.34277 13.7832 5.34277 14.5077C5.34277 15.2322 5.92946 15.8202 6.65527 15.8202H15.8139V24.6494C15.8139 25.3739 16.4006 25.9619 17.1264 25.9619C17.8522 25.9619 18.4389 25.3739 18.4389 24.6494V14.5077C18.4389 13.7832 17.8509 13.1952 17.1264 13.1952Z"
                fill="#1890FF"
            />
            <path
                d="M20.7656 13.5245C20.0398 13.5245 19.4531 14.1125 19.4531 14.837V16.626C19.4531 17.3505 20.0398 17.9385 20.7656 17.9385H26.6719C27.3977 17.9385 27.9844 17.3505 27.9844 16.626C27.9844 15.9015 27.3977 15.3135 26.6719 15.3135H22.0781V14.837C22.0781 14.1125 21.4914 13.5245 20.7656 13.5245Z"
                fill="#1890FF"
            />
            <path
                d="M16.5278 6.54827C15.802 6.54827 15.2153 7.13627 15.2153 7.86077V10.8428C15.2153 11.5673 15.802 12.1553 16.5278 12.1553C17.2536 12.1553 17.8403 11.5673 17.8403 10.8428V7.86077C17.8403 7.13627 17.2536 6.54827 16.5278 6.54827Z"
                fill="#1890FF"
            />
            <path
                d="M12.8896 4.84493H6.65527C5.92946 4.84493 5.34277 5.43293 5.34277 6.15743V10.9297C5.34277 11.6542 5.92946 12.2422 6.65527 12.2422H12.8896C13.6155 12.2422 14.2022 11.6542 14.2022 10.9297V6.15743C14.2022 5.43293 13.6155 4.84493 12.8896 4.84493ZM7.96777 7.46994H11.5771V9.61719H7.96777V7.46994Z"
                fill="#1890FF"
            />
        </g>
        <defs>
            <clipPath id="clip0_3017_13754">
                <rect
                    width="31.5"
                    height="31.5"
                    fill="white"
                    transform="matrix(1 0 0 -1 0.75 31.75)"
                />
            </clipPath>
        </defs>
    </svg>
);

const QRDisable = (
    <svg
        width="33"
        height="32"
        viewBox="0 0 33 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_3017_13754)">
            <path
                d="M30.9366 20.3365C30.2108 20.3365 29.6241 20.9245 29.6241 21.649V27.8703C29.6241 28.5619 29.061 29.125 28.3707 29.125H22.1494C21.4236 29.125 20.8369 29.713 20.8369 30.4375C20.8369 31.162 21.4236 31.75 22.1494 31.75H28.3707C30.51 31.75 32.2491 30.0096 32.2491 27.8703V21.649C32.2491 20.9245 31.6624 20.3365 30.9366 20.3365Z"
                fill="#95A0A8"
            />
            <path
                d="M2.0625 20.3365C1.33669 20.3365 0.75 20.9245 0.75 21.649V27.8702C0.75 30.0096 2.48906 31.75 4.62844 31.75H10.8497C11.5755 31.75 12.1622 31.162 12.1622 30.4375C12.1622 29.713 11.5755 29.125 10.8497 29.125H4.62844C3.93806 29.125 3.375 28.5619 3.375 27.8702V21.649C3.375 20.9245 2.78831 20.3365 2.0625 20.3365Z"
                fill="#95A0A8"
            />
            <path
                d="M28.3707 0.249586H22.1494C21.4236 0.249586 20.8369 0.837585 20.8369 1.56209C20.8369 2.28659 21.4236 2.87459 22.1494 2.87459H28.3707C29.061 2.87459 29.6241 3.43765 29.6241 4.12933V10.3506C29.6241 11.0751 30.2108 11.6631 30.9366 11.6631C31.6624 11.6631 32.2491 11.0751 32.2491 10.3506V4.12933C32.2491 1.98996 30.51 0.249586 28.3707 0.249586Z"
                fill="#95A0A8"
            />
            <path
                d="M10.8497 0.249586H4.62844C2.48906 0.249586 0.75 1.98996 0.75 4.12933V10.3506C0.75 11.0751 1.33669 11.6631 2.0625 11.6631C2.78831 11.6631 3.375 11.0751 3.375 10.3506V4.12933C3.375 3.43765 3.93806 2.87459 4.62844 2.87459H10.8497C11.5755 2.87459 12.1622 2.28659 12.1622 1.56209C12.1622 0.837585 11.5755 0.249586 10.8497 0.249586Z"
                fill="#95A0A8"
            />
            <path
                d="M13.1889 17.1038H6.65527C5.92946 17.1038 5.34277 17.6918 5.34277 18.4163V25.8437C5.34277 26.5682 5.92946 27.1562 6.65527 27.1562H13.1889C13.9147 27.1562 14.5014 26.5682 14.5014 25.8437V18.4163C14.5014 17.6918 13.9134 17.1038 13.1889 17.1038ZM7.96777 19.7288H11.8764V24.5312H7.96777V19.7288Z"
                fill="#95A0A8"
            />
            <path
                d="M26.3447 4.84375H20.1104C19.3845 4.84375 18.7979 5.43175 18.7979 6.15625V10.3326C18.7979 11.0571 19.3845 11.6451 20.1104 11.6451C20.8362 11.6451 21.4229 11.0571 21.4229 10.3326V7.46875H25.0322V11.4062H23.4809C22.755 11.4062 22.1684 11.9943 22.1684 12.7188C22.1684 13.4433 22.755 14.0312 23.4809 14.0312H26.3447C27.0705 14.0312 27.6572 13.4433 27.6572 12.7188V6.15625C27.6572 5.43175 27.0705 4.84375 26.3447 4.84375Z"
                fill="#95A0A8"
            />
            <path
                d="M26.345 19.1618H20.9756C20.2498 19.1618 19.6631 19.7498 19.6631 20.4743V25.8438C19.6631 26.5683 20.2498 27.1562 20.9756 27.1562H26.345C27.0708 27.1562 27.6575 26.5683 27.6575 25.8438V20.4743C27.6575 19.7498 27.0708 19.1618 26.345 19.1618ZM22.2881 21.7868H25.0325V24.5313H22.2881V21.7868Z"
                fill="#95A0A8"
            />
            <path
                d="M17.1264 13.1952H6.65527C5.92946 13.1952 5.34277 13.7832 5.34277 14.5077C5.34277 15.2322 5.92946 15.8202 6.65527 15.8202H15.8139V24.6494C15.8139 25.3739 16.4006 25.9619 17.1264 25.9619C17.8522 25.9619 18.4389 25.3739 18.4389 24.6494V14.5077C18.4389 13.7832 17.8509 13.1952 17.1264 13.1952Z"
                fill="#95A0A8"
            />
            <path
                d="M20.7656 13.5245C20.0398 13.5245 19.4531 14.1125 19.4531 14.837V16.626C19.4531 17.3505 20.0398 17.9385 20.7656 17.9385H26.6719C27.3977 17.9385 27.9844 17.3505 27.9844 16.626C27.9844 15.9015 27.3977 15.3135 26.6719 15.3135H22.0781V14.837C22.0781 14.1125 21.4914 13.5245 20.7656 13.5245Z"
                fill="#95A0A8"
            />
            <path
                d="M16.5278 6.54827C15.802 6.54827 15.2153 7.13627 15.2153 7.86077V10.8428C15.2153 11.5673 15.802 12.1553 16.5278 12.1553C17.2536 12.1553 17.8403 11.5673 17.8403 10.8428V7.86077C17.8403 7.13627 17.2536 6.54827 16.5278 6.54827Z"
                fill="#95A0A8"
            />
            <path
                d="M12.8896 4.84493H6.65527C5.92946 4.84493 5.34277 5.43293 5.34277 6.15743V10.9297C5.34277 11.6542 5.92946 12.2422 6.65527 12.2422H12.8896C13.6155 12.2422 14.2022 11.6542 14.2022 10.9297V6.15743C14.2022 5.43293 13.6155 4.84493 12.8896 4.84493ZM7.96777 7.46994H11.5771V9.61719H7.96777V7.46994Z"
                fill="#95A0A8"
            />
        </g>
        <defs>
            <clipPath id="clip0_3017_13754">
                <rect
                    width="31.5"
                    height="31.5"
                    fill="#ECECEC"
                    transform="matrix(1 0 0 -1 0.75 31.75)"
                />
            </clipPath>
        </defs>
    </svg>
);

export default TemplateLink;
